import { FilteringOptions, SortType } from 'ngrx-data-grid';
import * as R from 'ramda';

export const getDisplaySettingsField: any = R.cond([
  [R.equals('processType'), R.always('processType.id')],
  [R.equals('trainType'), R.always('trainTypeId')],
  [R.equals('internationalTrainNumber'), R.always('internationalTrainNr')],
  [R.equals('dossierStatus'), R.always('dossierStatus.id')],
  [R.T, R.identity]
]);

type GetDisplaySettingsFilterOption = (o: string) => FilteringOptions;
export const getDisplaySettingsFilterOption: GetDisplaySettingsFilterOption = R.cond([
  [R.equals('eq'), R.always(FilteringOptions.Equals)],
  [R.equals('neq'), R.always(FilteringOptions.NotEqual)],
  [R.equals('startswith'), R.always(FilteringOptions.StartsWith)],
  [R.T, R.identity as any]
]);

type GetDisplaySettingsSortType = (o: string) => SortType;
export const getDisplaySettingsSortType: GetDisplaySettingsSortType = R.cond([
  [R.equals('asc'), R.always(SortType.Ascending)],
  [R.equals('desc'), R.always(SortType.Descending)],
  [R.T, R.identity as any]
]);
